import { LegalClientLicenseInfoParam } from 'api/types/params';
import { formatToISODate } from 'helpers';
import { YesOrNoType } from 'types/yesOrNo';

import { CompanyLicenseFormType } from '../../forms/companyLicenseForm';

export const parseLicenseParam = (
  values: CompanyLicenseFormType
): LegalClientLicenseInfoParam => {
  const isLicensed =
    values.companyLicense.companyActivityIsLicensed?.value === YesOrNoType.Yes;

  if (!isLicensed) {
    return { isLicensed, licenses: null };
  }

  return {
    isLicensed,
    licenses: values.companyLicense.licenses.map((license) => ({
      activityType: license.licensedActivityType!,
      issueDate: formatToISODate(license.dateOfIssue!),
      issuingAuthority: license.authorityName!,
      licenseNumber: license.licenseNumber!,
      expirationDate: license.dateOfExpiry
        ? formatToISODate(license.dateOfExpiry)
        : undefined,
      fileIds: license.files?.map(({ id }) => id!)!,
    })),
  };
};
